import { useI18n } from '../../i18n'
import {
   closeSleepEditModal,
   editingSleepEnd,
   editingSleepStart,
   isSleepEditModalOpen,
   saveEditedSleep,
   setEditingSleepEnd,
   setEditingSleepStart,
   sleepEditError,
} from '../../state/sleepStore'
import DateTimeField from '../ui/DateTimeField'
import EditEntryModal from './EditEntryModal'

/**
 * Renders the sleep edit modal: when the sleep started and when it ended (left
 * empty while still asleep).
 *
 * @returns The modal element.
 */
const SleepEditModal = () => {
   const t = useI18n()

   return (
      <EditEntryModal
         id="sleep-edit-modal"
         open={isSleepEditModalOpen()}
         title={t('Edit sleep')}
         error={sleepEditError()}
         saveId="sleep-edit-save-btn"
         cancelId="sleep-edit-cancel-btn"
         onSave={saveEditedSleep}
         onCancel={closeSleepEditModal}
      >
         <DateTimeField
            id="sleep-edit-start"
            label={t('Fell asleep')}
            value={editingSleepStart()}
            onValueInput={setEditingSleepStart}
         />
         <DateTimeField
            id="sleep-edit-end"
            label={t('Woke up (leave empty while still asleep)')}
            value={editingSleepEnd()}
            onValueInput={setEditingSleepEnd}
         />
      </EditEntryModal>
   )
}

export default SleepEditModal
